import React from 'react'
import { ToastContainer } from 'react-toastify';
import "react-toastify/dist/ReactToastify.css";
const NotificationHandler = () => {
  return (
    <ToastContainer 
    limit={1}       // فقط یک toast در یک زمان
      autoClose={1000} // بستن خودکار پس از ۳ ثانیه (قابل تنظیم)
      newestOnTop      // جدیدترین toast در بالا نمایش داده شود
      closeOnClick     // بستن با کلیک روی toast
      pauseOnHover     // توقف تایمر هنگام هاور
    />
  )
}

export default NotificationHandler;
